import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import Spinner from 'react-bootstrap/Spinner';
import * as apiUtility from "../../config/APIUtils";
import { Icon, IconButton, Paper, Tooltip, Box, Typography, Button } from "@mui/material";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import ErrorPopUp from '../Utility/ErrorPopUp';
import { RiFileExcel2Line } from "react-icons/ri";
import { RxInfoCircled } from 'react-icons/rx';

function HomeSummary(props) {
    const [homeSummData, setHomeSummData] = useState([]);
    const [showSpinner, setshowSpinner] = useState(false);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [dataForErrorPopup, setDataForErrorPopup] = useState('');

    var homeID = props.homeId;
    var staffFlag = props.staffFlag;

    useEffect(() => {
        let mounted = true;
        const fetchData = async () => {
            setshowSpinner(true);
            try {
                const apiRequest1 = apiUtility.apiInputRequest;
                apiRequest1.endPoint = "audit-report/home-summary/" + homeID + "/" + staffFlag;
                const res1 = await apiUtility.fetchAsyncAPIDataGET(apiRequest1);

                 const apiRequest2 = apiUtility.apiInputRequest;
                apiRequest2.endPoint = "audit-report/home-policy-summary/" + homeID + "/" + staffFlag;
                const res2 = await apiUtility.fetchAsyncAPIDataGET(apiRequest2);
                //if (!mounted) return;
                let homeSumData = Array.isArray(res1.data) ? res1.data : [];
                let homePolicySumData = Array.isArray(res2.data) ? res2.data : [];
                var finalArr = [];
                for(var i=0;i<homeSumData.length;i++){
                    if(props.crsPolicyType && props.crsPolicyType=='9' || props.crsPolicyType=='11'){
                    homeSumData[i]['type'] = 'Course'
                    finalArr.push(homeSumData[i]);
                    }
                    
                    if(props.crsPolicyType && props.crsPolicyType=='10' || props.crsPolicyType=='11'){
                        homePolicySumData[i]['type'] = 'Home Doc'
                    finalArr.push(homePolicySumData[i]);
                    }
                    
                }
                console.log(finalArr)
                if (!mounted) return;
                setHomeSummData(finalArr);
                
            } catch (error) {
                console.error("Error fetching home summary:", error);
                if (mounted) {
                    setDataForErrorPopup("Unable to fetch home summary. Please try again.");
                    setShowErrorPopup(true);
                    setHomeSummData([]);
                }
            } finally {
                if (mounted) setshowSpinner(false);
            }
        };
        if (homeID !== undefined && homeID !== null) fetchData();
        return () => {
            mounted = false;
        };
    }, [homeID, staffFlag])

    if (homeSummData == null) {
        return <h1>
            {/* Loading */}
        </h1>
    }

    const holdUsersFormatter = (data, row) => {
        return row.hold_users;
    };

    var homeSummCols = [{
        dataField: 'role_id',
        sort: true,
        text: 'Role ID'
    }, {
        dataField: 'role_name',
        sort: true,
        text: 'Role Name'
    },
    {
        dataField: 'type',
        sort: true,
        text: 'Course/Home Docs'
    },
    {
        dataField: 'total_courses',
        sort: true,
        text: 'Total Courses/Home Docs'
    }, {
        dataField: 'total_staff',
        sort: true,
        text: 'Total Staff'
    }
        , {
        dataField: 'complaint_staff',
        sort: true,
        text: 'Compliant Staff'
    }
        , {
        dataField: 'non_complaint_staff',
        sort: true,
        text: 'Non-Compliant Staff'
    }, {
        dataField: 'hold_users',
        sort: true,
        text: 'Unknown',
        headerFormatter: (cell, row) => (
            <span>
                {"Unknown"} &nbsp;
                <Tooltip variant="contained" title="Users that have been added to the home but do not consent to share their records" disableRipple>
                    <Icon color='primary' style={{ "fontSize": "15px" }}>
                        <RxInfoCircled style={{ "marginBottom": "9px" }} />
                    </Icon>
                </Tooltip>
            </span>
        ),
        formatter: holdUsersFormatter
    }
    ];

    const workbook2blob = (workbook) => {
        const wopts = {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
        };
        const wbout = XLSX.write(workbook, wopts);
        const blob = new Blob([s2ab(wbout)], {
            type: "application/octet-stream",
        });
        return blob;
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; i++) {
            view[i] = s.charCodeAt(i);
        }
        return buf;
    }

    //Excel
    const exportInExcel = async () => {
        try {
            var rowsCount = 6;
            const title = [{ A: 'CarePassport - Summary Report for Home ID : ' + String(homeID) }];
            let reportView = [{ A: 'Name', B: 'User ID', C: 'Role', D: 'Date' }];
            reportView.push({
                A: sessionStorage.getItem('fullName'),
                B: sessionStorage.getItem('userId'),
                C: (sessionStorage.getItem('userType') !== null) ? sessionStorage.getItem('userType').toUpperCase() : "User",
                D: new Date().toLocaleString()
            });
            reportView.push("");
            reportView.push("");
            let reportHeaders = { A: 'Role ID', B: 'Role Name', C:'Course/Home Doc', D: 'Total Courses/Home Docs',E:'Total Staff', F: 'Compliant Staff', G: 'Non-Compliant Staff', H: 'Unknown' };
            reportView.push(reportHeaders);
            // orgStaffTemplateData.forEach(element => {
            homeSummData.forEach(element => {
                rowsCount += 1;
                var tempObj = {
                    A: element.role_id,
                    B: element.role_name,
                    C: element.type,
                    D: element.total_courses,
                    E: element.total_staff,
                    F: element.complaint_staff,
                    G: element.non_complaint_staff,
                    H: element.hold_users,
                    // I: element.total_courses,
                };
                reportView.push(tempObj);
            });
            const finalData = [...title, ...reportView];
            const worksheet = XLSX.utils.json_to_sheet(finalData, {
                skipHeader: true,
            });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Home Summary");
            const workbookblob = workbook2blob(workbook);
            var headerIndexes = [];
            finalData.forEach((data, index) =>
                data["A"] === "Role ID" ? headerIndexes.push(index) : null
            );
            const dataInfo = {
                titleCell: "A2",
                titleRange: "A1:H1",
                tbodyRange: `A7:G${finalData.length}`,
                uHeadRange: `A2:D2`,
                uBodyRange: `A3:D3`,
                theadRange:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[0] + 1}:G${headerIndexes[0] + 1}`
                        : null,
                theadRange1:
                    headerIndexes?.length >= 2
                        ? `A${headerIndexes[1] + 1}:I${headerIndexes[1] + 1}`
                        : null,
                tFirstColumnRange:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[0] + 1}:A${rowsCount + headerIndexes[0] + 1}`
                        : null,
                tLastColumnRange:
                    headerIndexes?.length >= 1
                        ? `K${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[0] + 1}`
                        : null,

                tFirstColumnRange1:
                    headerIndexes?.length >= 1
                        ? `A${headerIndexes[1] + 1}:A${rowsCount + headerIndexes[1] + 1}`
                        : null,
                tLastColumnRange1:
                    headerIndexes?.length >= 1
                        ? `H${headerIndexes[0] + 1}:I${rowsCount + headerIndexes[1] + 1}`
                        : null,
            };
            XlsxPopulate.fromDataAsync(workbookblob).then((workbook) => {
                workbook.sheets().forEach((sheet) => {
                    sheet.column("A").width(15);
                    sheet.column("B").width(30);
                    sheet.column("C").width(20);
                    sheet.column("D").width(20);
                    sheet.column("E").width(20);
                    sheet.column("F").width(20);
                    sheet.column("G").width(20);
                    sheet.column("H").width(20);
                    sheet.range(dataInfo.titleRange).merged(true).style({
                        bold: true,
                        fontFamily: "Arial",
                        horizontalAlignment: "center",
                        verticalAlignment: "center",
                    });
                    sheet.range(dataInfo.uHeadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    sheet.range(dataInfo.uBodyRange).style({
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tbodyRange) {
                        sheet.range(dataInfo.tbodyRange).style({
                            horizontalAlignment: "left",
                        });
                    }
                    sheet.range(dataInfo.theadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.tFirstColumnRange) {
                        sheet.range(dataInfo.tFirstColumnRange).style({
                            bold: true,
                        });
                    }

                });

                return workbook.outputAsync().then((workbookBlob) => {
                    const downloadAnchorNode = document.createElement("a");
                    var dateVar = new Date();
                    var fileName = "Carepassport_HomeSummaryReport-" + dateVar.getDate() + dateVar.getMonth() + dateVar.getFullYear() + "_" + dateVar.getHours() + dateVar.getMinutes() + ".xlsx";
                    downloadAnchorNode.setAttribute("href", URL.createObjectURL(workbookBlob));
                    downloadAnchorNode.setAttribute("download", fileName);
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();
                });
            });
        } catch (error) {
            setDataForErrorPopup("Something went wrong while processing excel!");
            setShowErrorPopup(true);
        }
    }


    return (
        <div key={homeID}>
            {showSpinner && (
                <div style={{ position: "fixed", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, background: "rgba(255,255,255,0.5)" }}>
                    <Spinner animation="border" size="lg" variant='primary' />
                </div>
            )}
            <Paper sx={{ p: 1, borderRadius: "1.5px" }}>
                {(!showSpinner && homeSummData.length === 0) ? (
                    <Box sx={{ p: 6, textAlign: "center" }}>
                        <Typography variant="h6" gutterBottom>No data available</Typography>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            There are no summary records for the selected home / filters.
                        </Typography>
                        <Button variant="outlined" onClick={() => {
                            // quick manual retry: toggle spinner to give feedback; effect will refetch when props change
                            setshowSpinner(true);
                            setTimeout(() => setshowSpinner(false), 300);
                        }}>Retry</Button>
                    </Box>
                ) : (
                    <BootstrapTable id='homeSummaryTable' keyField='id' data={homeSummData} columns={homeSummCols} striped hover />
                )}
                <Row>
                    <Col xs={0} md={8}></Col>
                    <Col xs={12} md={4} className="text-center">
                        <Paper component="form" variant="outlined"
                            sx={{ float: "right", display: 'flex', marginBottom: "4px", alignItems: 'center', width: 50 }}
                        >
                            <Tooltip variant="contained" title="Export to Excel" disableRipple>
                                <IconButton color="primary" onClick={exportInExcel} sx={{ p: '10px' }} aria-label="directions">
                                    <RiFileExcel2Line />
                                </IconButton>
                            </Tooltip>
                        </Paper>
                    </Col>
                </Row>
            </Paper>
            <ErrorPopUp show={showErrorPopup} data={dataForErrorPopup} onHide={() => { setShowErrorPopup(false) }} />
        </div>
    );
}

export default HomeSummary;